import { render, staticRenderFns } from "./LedgerTransactionFeeModal.vue?vue&type=template&id=087c3224&scoped=true"
import script from "./LedgerTransactionFeeModal.vue?vue&type=script&lang=js"
export * from "./LedgerTransactionFeeModal.vue?vue&type=script&lang=js"
import style0 from "./LedgerTransactionFeeModal.vue?vue&type=style&index=0&id=087c3224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c3224",
  null
  
)

export default component.exports